export const CANCEL_NEWSCANTOOL = 'CANCEL_NEWSCANTOOL'
export const ADD_SCANTOOL = 'ADD_SCANTOOL'
export const SET_SCANTOOLS = 'SET_SCANTOOLS'
export const SET_SCANTOOL = 'SET_SCANTOOL'
export const CANCEL_NEWREPORTTEMPLATE = 'CANCEL_NEWREPORTTEMPLATE'
export const ADD_REPORT_TEMPLATE = 'ADD_REPORT_TEMPLATE'
export const SET_REPORT_TEMPLATES = 'SET_REPORT_TEMPLATES'
export const SET_REPORT_TEMPLATE = 'SET_REPORT_TEMPLATE'
export const SAVE_TECH_INFO = 'SAVE_TECH_INFO'



// WEBPACK FOOTER //
// ./src/store/modules/report/types.js